<template>
  <div class="formCom">
    <div class="form">
      <button class="close" @click="closeAdminInfoModal">
        <CloseIcone></CloseIcone>
      </button>
      <div class="name">
        Edit Admin Info
      </div>
      <div class="input-wrap">
        <input
          type="text"
          class="input"
          placeholder="First Name"
          v-model="form.first_name"
          name="lastName"
          :class="{ invalid: errors.has('first_name') }"
          v-validate="'required|max:50'"
        />
      </div>
      <div class="input-wrap">
        <input
          type="text"
          class="input"
          placeholder="Last name"
          v-model="form.last_name"
          name="last_name"
          :class="{ invalid: errors.has('last_name') }"
          v-validate="'required|max:50'"
        />
      </div>
      <!--<div class="input-wrap">-->
      <!--<input-->
      <!--type="text"-->
      <!--class="input toLowerCase"-->
      <!--placeholder="Email"-->
      <!--v-model="form.email"-->
      <!--name="Email"-->
      <!--:class="{invalid: errors.has('Email')}"-->
      <!--v-validate="'required|max:50|email'"-->
      <!--&gt;-->
      <!--</div>-->
      <button
        class="btn"
        @click.prevent="$validator.validateAll()"
        @click="editAdminInfo"
      >
        Submit
      </button>
      <div class="txt">{{ txt }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CloseIcone from "../../images/shared/cancel";

export default {
  name: "EditeAdminInfo",
  props: ["AdminInfo"],
  data() {
    return {
      id: null,
      form: {
        first_name: null,
        last_name: null,
        email: null
      },
      txt: ""
    };
  },
  components: {
    CloseIcone
  },
  methods: {
    ...mapActions(["EditAdmin"]),
    closeAdminInfoModal() {
      this.$emit("closeAdminInfoModal", false);
    },
    editAdminInfo() {
      if (this.errors.any() || !this.isComplete) {
        return;
      }
      this.EditAdmin(this._data).then(res => {
        this.txt = "Admin Info successfully Updated";
      });
    }
  },
  computed: {
    isComplete() {
      return this.form.first_name && this.form.last_name;
    }
  },
  mounted() {
    this.form.first_name = this.AdminInfo.first_name;
    this.form.last_name = this.AdminInfo.last_name;
    this.form.email = this.AdminInfo.email;
    this.id = this.AdminInfo.id;
  }
};
</script>

<style scoped>
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}
.formCom {
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
.input.invalid {
  border: 1px solid red;
}
.form {
  padding: 30px;
  background-color: #fff;
  max-width: 350px;
  width: 100%;
  position: relative;
  z-index: 1;
}
.input-wrap {
  width: 100%;
  margin: 0 0 15px 0;
}
.input {
  border: 1px solid #e4e4e4;
  border-radius: 2px;
  padding: 15px 20px;
  color: #4d4d4d;
  width: 100%;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  text-align: center;
  outline: none;
}
.input::placeholder {
  color: #98a4ae;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.btn {
  background-color: #62b039;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsMedium, sans-serif;
}
.btn.change {
  height: auto;
  width: auto;
  margin: 10px auto 0 auto;
  border-radius: 0px;
  padding: 0;
  color: #62b039;
  background-color: transparent;
}
.btn:disabled {
  cursor: default;
  background-color: rgba(108, 194, 74, 0.2);
  color: #62b039;
}
.btn:hover:enabled {
  background-color: transparent;
  color: #62b039;
  border: 1px solid #62b039;
}
.btn.change:hover:enabled {
  background-color: transparent;
  color: #62b039;
  border: 1px solid transparent;
}
.name {
  color: #005eb8;
  font-size: 24px;
  margin: 0 0 30px 0;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
.txt {
  color: green;
  font-size: 14px;
  margin: 15px 0 0px 0;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
</style>
